<template>
  <f7-page class="with-bg-image">
    <container>
      <f7-block-title class="text-align-center" large>
        <h1>
          {{ $t(`page_home.h1.normal`) }}
          <span class="text-color-blue">
            {{ $t(`page_home.h1.mark`) }}
          </span>
        </h1>
      </f7-block-title>

      <f7-block class="margin-top text-align-center">
        {{ $t(`page_home.subtitle`) }}
      </f7-block>

      <!-- <f7-block class="select-lang-block">
      <f7-button class="active" large round>English</f7-button>
      <f7-button large round>Spanish</f7-button>
    </f7-block> -->

      <f7-block class="search-block">
        <search
          custom-search
          search-container="#search-course-output"
          search-in=".course-card.course-card-wide .course-card-title"
          :val="searchValue"
          @on-debounce-search="debounceSearch"
        ></search>

        <div v-if="example.length" class="search-block-examples">
          {{ $t(`example`) }}:
          <f7-button @click="pastToSearch(example[0])">
            {{ example[0] }}
          </f7-button>
          {{ example[1] && $t(`or`) }}
          <f7-button v-if="example[1]" @click="pastToSearch(example[1])">
            {{ example[1] }}
          </f7-button>
        </div>
      </f7-block>

      <f7-block class="display-flex justify-content-center">
        <f7-button fill class="margin-right-half" @click="showRecommended">
          {{ $t(`recommended`) }}
        </f7-button>

        <f7-button fill @click="showAll">
          {{ $t(`all_course`) }}
        </f7-button>
      </f7-block>

      <f7-block
        v-show="!found.length && showCourse === 'recommended'"
        class="course-card-wrapper"
      >
        <div class="course-card-wrapper-inner">
          <f7-link
            v-for="course in recommendedCourses"
            :key="course.id"
            :href="`/course/${course.id}`"
            class="link-card-wrapper"
          >
            <f7-card class="course-card">
              <f7-card-header
                :style="`background-image: url(${BASE_PATH}/${course.preview})`"
              >
                <f7-button
                  v-if="$store.state.user.info"
                  class="course-card-favorite"
                  icon-f7="heart_fill"
                  icon-size="30"
                  :icon-color="
                    favoritesCourse.find((id) => id == course.id)
                      ? 'red'
                      : 'gray'
                  "
                  @click.stop="
                    $store.dispatch('course/addToFavorites', course.id)
                  "
                >
                </f7-button>
              </f7-card-header>

              <f7-card-content>
                <h2 class="course-card-title">{{ course.name }}</h2>
                <div class="course-card-body">
                  <div
                    class="course-card-rating display-flex align-items-center"
                  >
                    <star-rating
                      :increment="1"
                      :max-rating="5"
                      :star-size="18"
                      :show-rating="false"
                      :rating="course.rating.avg"
                      read-only
                      inactive-color="#CBCBCB"
                      active-color="#F4C150"
                    ></star-rating>

                    <div class="course-card-rating-info margin-left-half">
                      <b>{{ course.rating.avg }}</b>
                      {{ `(${course.rating.count})` }}
                    </div>
                  </div>
                  <div class="course-card-coast">
                    <del>
                      {{ `${course.price.base}$` }}
                    </del>

                    <b>
                      {{ `${course.price.special}$` }}
                    </b>
                  </div>
                </div>
              </f7-card-content>
            </f7-card>
          </f7-link>
        </div>
      </f7-block>

      <f7-list
        v-show="!found.length && showCourse === 'all'"
        id="search-course-output"
        class="search-output"
        simple-list
        no-hairlines
        no-hairlines-between
      >
        <f7-list-item v-for="course in courses" :key="course.id">
          <f7-card
            class="course-card course-card-wide"
            @click.native="$f7router.navigate(`/course/${course.id}`)"
          >
            <f7-card-header
              :style="`background-image: url(${BASE_PATH}${course.preview})`"
            >
              <f7-button
                v-if="$store.state.user.info"
                class="course-card-favorite"
                icon-f7="heart_fill"
                icon-size="30"
                :icon-color="
                  favoritesCourse.find((id) => id == course.id) ? 'red' : 'gray'
                "
                @click.stop="
                  $store.dispatch('course/addToFavorites', course.id)
                "
              >
              </f7-button>
            </f7-card-header>

            <f7-card-content>
              <div>
                <h2 class="course-card-title">{{ course.name }}</h2>

                <div class="course-card-meta">
                  <!-- <span>5 лекций</span> -->
                  <span>{{ `${course.time}` }}</span>
                  <!-- <span>Уровни: A1,A2,C2,C2</span> -->
                </div>

                <p class="course-card-text">
                  {{ course.desc.short }}
                </p>
              </div>

              <div class="course-card-body">
                <div class="course-card-coast">
                  <del>
                    {{ `${course.price.base}$` }}
                  </del>

                  <b>
                    {{ `${course.price.special}$` }}
                  </b>
                </div>

                <div class="course-card-rating">
                  <star-rating
                    :increment="1"
                    :max-rating="5"
                    :star-size="18"
                    :show-rating="false"
                    :rating="course.rating.avg"
                    read-only
                    inactive-color="#CBCBCB"
                    active-color="#F4C150"
                  ></star-rating>

                  <div class="course-card-rating-info margin-left-half">
                    <b>{{ course.rating.avg }}</b>
                    {{ `(${course.rating.count})` }}
                  </div>
                </div>
              </div>
            </f7-card-content>
          </f7-card>
        </f7-list-item>
      </f7-list>

      <f7-list
        v-show="found.length && searchValue.length"
        id="search-course-output"
        class="search-output"
        simple-list
        no-hairlines
        no-hairlines-between
      >
        <f7-list-item v-for="course in found" :key="course.id">
          <f7-card
            class="course-card course-card-wide"
            @click.native="$f7router.navigate(`/course/${course.id}`)"
          >
            <f7-card-header
              :style="`background-image: url(${BASE_PATH}${course.preview})`"
            >
              <f7-button
                v-if="$store.state.user.info"
                class="course-card-favorite"
                icon-f7="heart_fill"
                icon-size="30"
                :icon-color="
                  favoritesCourse.find((id) => id == course.id) ? 'red' : 'gray'
                "
                @click.stop="
                  $store.dispatch('course/addToFavorites', course.id)
                "
              >
              </f7-button>
            </f7-card-header>

            <f7-card-content>
              <div>
                <h2 class="course-card-title">{{ course.name }}</h2>

                <div class="course-card-meta">
                  <!-- <span>5 лекций</span> -->
                  <span>{{ `${course.time}` }}</span>
                  <!-- <span>Уровни: A1,A2,C2,C2</span> -->
                </div>

                <p class="course-card-text">
                  {{ course.desc.short }}
                </p>
              </div>

              <div class="course-card-body">
                <div class="course-card-coast">
                  <del>
                    {{ `${course.price.base}$` }}
                  </del>

                  <b>
                    {{ `${course.price.special}$` }}
                  </b>
                </div>

                <div class="course-card-rating">
                  <star-rating
                    :increment="1"
                    :max-rating="5"
                    :star-size="18"
                    :show-rating="false"
                    :rating="course.rating.avg"
                    read-only
                    inactive-color="#CBCBCB"
                    active-color="#F4C150"
                  ></star-rating>

                  <div class="course-card-rating-info margin-left-half">
                    <b>{{ course.rating.avg }}</b>
                    {{ `(${course.rating.count})` }}
                  </div>
                </div>
              </div>
            </f7-card-content>
          </f7-card>
        </f7-list-item>
      </f7-list>
    </container>

    <page-footer></page-footer>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { BASE_PATH } from '../js/const/index.js';

import StarRating from 'vue-star-rating';
import Container from '@/components/Container.vue';
import Search from '@/components/Search.vue';
import PageFooter from '@/components/Footer.vue';

export default {
  name: 'Home',

  components: {
    StarRating,
    Container,
    Search,
    PageFooter,
  },

  data() {
    return {
      searchValue: '',
      showCourse: 'recommended',
    };
  },

  computed: {
    BASE_PATH: () => BASE_PATH,

    example() {
      const arr = this.courses.map((course) => course.name);
      return arr;
    },

    recommendedCourses() {
      return this.courses.filter((course) => course.recommended);
    },

    ...mapState({
      appConfig: (state) => state.appConfig,
      courses: (state) => state.course.courses,
      favoritesCourse: (state) =>
        state.course.favorites.map((course) => course.id),
      found: (state) => state.course.found,
    }),
  },

  created() {
    this.getCourses();
  },

  methods: {
    debounceSearch(val) {
      this.searchValue = val;
      this.searchCourses(val);
    },

    pastToSearch(text) {
      this.searchValue = text;
      this.searchCourses(text);
    },

    showAll() {
      this.showCourse = 'all';
      this.pastToSearch('');
    },

    showRecommended() {
      this.showCourse = 'recommended';
      this.pastToSearch('');
    },

    ...mapActions({
      getCourses: 'course/getCourses',
      searchCourses: 'course/searchCourses',
    }),
  },
};
</script>
